<mat-toolbar color="primary">
    <div class="w-full flex justify-between items-center">
        <div class="flex justify-between items-center">
            <div>
                <button (click)="onToggleSidenav()" mat-icon-button>
                    <mat-icon>menu</mat-icon>
                </button>
            </div>
            <div>
                <a [routerLink]="['/']" class="ml-2 logo" routerLinkActive="active">
                    LIDO
                </a>
            </div>
        </div>

        <div class="flex justify-between items-center">
            @if (organizationList?.length && (auth.isAuthenticated$ | async)) {
                <div class="mx-2">
                    <button [matMenuTriggerFor]="orgs" mat-button>
                        <mat-icon>store</mat-icon>

                        @if (currentOrg) {
                            <span>Acting for {{currentOrg.name}}</span>
                        } @else {
                            <span>Select Organization</span>
                        }

                    </button>

                    <mat-menu #orgs="matMenu">
                        @for (org of organizationList; track org) {
                            <button (click)="selectOrganization(org)" mat-menu-item>
                                {{org.name}}
                            </button>
                        }
                    </mat-menu>
                </div>
            }

            <div class="mx-2 justify-end hidden sm:flex">
                <ul class="flex gap-5 navigation-items">
                    @if((auth.isAuthenticated$ | async) === false) {
                        <app-auth-button></app-auth-button>
                        <button mat-button (click)="signUp()">Signup</button>
                    }
                    @else {
                        <button (click)="logout()">Logout</button>
                    }
                </ul>
            </div>
        </div>
    </div>
</mat-toolbar>
